RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Emails = Backbone.Collection.extend({
        model: Backbone.Model.extend({
            idAttribute: 'email',
            validate: function (attrs) {
                const me = this;
                const email = attrs.email;

                if (!email) {
                    return true;
                }

                if (me.collection.get(email)) {
                    me.collection.trigger('add:duplicate', me);
                    return true;
                }

                if (!email.match(/.+@.+/) && !email.match(/<|>/g)) {
                    me.collection.trigger('add:malformed', me);
                    return true;
                }
            }
        }),

        toJSON: function () {
            const me = this;
            return me.pluck('email');
        },

        cloneDeep: function () {
            const me = this;
            return new collections.Emails(me.invoke('toJSON'));
        }
    });
});
